import request from '@/utils/request'

const tradeCategoryParameterApi = {
  trade_product_parameter_list: '/trade/product_parameter/',
  trade_product_parameter_create: '/trade/product_parameter/',
  trade_product_parameter_update: '/trade/product_parameter/',
  trade_product_parameter_delete: '/trade/product_parameter/'
}

/**
 * 列表
 */
export function product_parameter_list (parameter) {
  return request({
    url: tradeCategoryParameterApi.trade_product_parameter_list,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}
/**
 * 添加
 */
export function product_parameter_create (parameter) {
  return request({
    url: tradeCategoryParameterApi.trade_product_parameter_create,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 修改
 */
export function product_parameter_update (parameter, category_id) {
  return request({
    url: tradeCategoryParameterApi.trade_product_parameter_update + category_id + '/',
    method: 'put',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 删除
 */
export function product_parameter_delete (category_id) {
  return request({
    url: tradeCategoryParameterApi.trade_product_parameter_delete + category_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
